import React from "react";
import Footer from "../components/Common/Footer/footer";
import Header from "../components/Common/Header";
import LandingIntro from "../components/LandingPage/Intro";

function Home() {
  return (
    <div>
      <Header />
      <LandingIntro />
      <Footer />
    </div>
  );
}

export default Home;
